export enum PromoCodeType {
  Absolute = 'absolute',
  Relative = 'relative',
  Absolute_Article = 'absolute_article',
  Relative_Article = 'relative_article',
  Gift_Card = 'gift_card',
  Delivery_Fee = 'delivery_fee',
  Bogo = 'bogo',
  Reward = 'reward',
  Free_Article = 'free_article',
  Void = 'void',
  Most_Expensive_Article_Discount_Relative = 'most_expensive_article_discount_relative',
  Teedeli_Premium = 'teedeli_premium',
  Article_Discount_Absolute = 'article_discount_absolute',
  Coupon = 'coupon',
  Dependency_Free_Article = 'dependency_free_article',
  Cheapest_Free_Article = 'cheapest_free_article',
  Single_Absolute_Article = 'single_absolute_article',
  Single_Relative_Article = 'single_relative_article',
  Multiple_Absolute_Article = 'multiple_absolute_article',
  Multiple_Relative_Article = 'multiple_relative_article',
  Unlock_Articles = 'unlock_articles',
  Cheapest_Half_Article_Discount_Relative = 'cheapest_half_article_discount_relative',
  Multiple_Free_Articles = 'multiple_free_articles',
}
